import { render, staticRenderFns } from "./ModalApproveOrder.vue?vue&type=template&id=2a31a7d4&"
import script from "./ModalApproveOrder.vue?vue&type=script&lang=ts&"
export * from "./ModalApproveOrder.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports